import { createUseStyles } from 'react-jss'
import { neonLime } from '../../../styles/colors'
import MediaQueries from '../../../styles/MediaQueries'

const useStyles = createUseStyles({
  video: {
    padding: '0 25px',
    display: 'flex',
    justifyContent: 'center',
    position: 'relative'
  },
  videoRatio: {
    '&:before': {
      paddingTop: '56.25%',
      content: '""',
      display: 'block'
    },
    flex: 1,
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '8px'
  },
  videoContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  },
  videoPlayer: {
    height: '100%',
    width: '100%',
    '@global': {
      '.vjs-big-play-button': {
        display: 'none'
      },
      '.vjs-menu-button-popup .vjs-menu .vjs-menu-item.vjs-selected, .vjs-play-progress': {
        backgroundColor: neonLime
      },
      '.vjs-volume-panel .vjs-slider-horizontal .vjs-volume-level': {
        backgroundColor: neonLime
      },
      '.vjs-progress-control .vjs-slider-bar .vjs-time-tooltip': {
        display: 'none !important'
      }
    }
  },
  '@global': {
    ':not(.vjs-fullscreen) > .vjs-control-bar': {
      display: 'none'
    },
    ':not(.vjs-paused) > .vjs-control-bar': {
      display: 'flex'
    }
  },
  [MediaQueries.Tablet]: {
    videoRatio: {
      maxWidth: '691px'
    }
  },
  [MediaQueries.LaptopSmall]: {
    videoRatio: {
      maxWidth: '834px'
    }
  },
  [MediaQueries.LaptopLarge]: {
    videoRatio: {
      maxWidth: '964px'
    }
  }
})

export default useStyles
